/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BalanceSheetsRouteImport } from './routes/balance-sheets'
import { Route as BalanceSheetRouteImport } from './routes/balance-sheet'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BalanceSheetIdRouteImport } from './routes/balance-sheet/$id'
import { Route as BalanceSheetIdIndexRouteImport } from './routes/balance-sheet/$id.index'
import { Route as BalanceSheetIdTableRouteImport } from './routes/balance-sheet/$id.table'
import { Route as BalanceSheetIdSettingsRouteImport } from './routes/balance-sheet/$id.settings'
import { Route as BalanceSheetIdDashboardRouteImport } from './routes/balance-sheet/$id.dashboard'
import { Route as BalanceSheetIdAccountsRouteImport } from './routes/balance-sheet/$id.accounts'
import { Route as BalanceSheetIdAccountTypesRouteImport } from './routes/balance-sheet/$id.account-types'

const BalanceSheetsRoute = BalanceSheetsRouteImport.update({
  id: '/balance-sheets',
  path: '/balance-sheets',
  getParentRoute: () => rootRouteImport,
} as any)
const BalanceSheetRoute = BalanceSheetRouteImport.update({
  id: '/balance-sheet',
  path: '/balance-sheet',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BalanceSheetIdRoute = BalanceSheetIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BalanceSheetRoute,
} as any)
const BalanceSheetIdIndexRoute = BalanceSheetIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BalanceSheetIdRoute,
} as any)
const BalanceSheetIdTableRoute = BalanceSheetIdTableRouteImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => BalanceSheetIdRoute,
} as any)
const BalanceSheetIdSettingsRoute = BalanceSheetIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => BalanceSheetIdRoute,
} as any)
const BalanceSheetIdDashboardRoute = BalanceSheetIdDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => BalanceSheetIdRoute,
} as any)
const BalanceSheetIdAccountsRoute = BalanceSheetIdAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => BalanceSheetIdRoute,
} as any)
const BalanceSheetIdAccountTypesRoute =
  BalanceSheetIdAccountTypesRouteImport.update({
    id: '/account-types',
    path: '/account-types',
    getParentRoute: () => BalanceSheetIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/balance-sheet': typeof BalanceSheetRouteWithChildren
  '/balance-sheets': typeof BalanceSheetsRoute
  '/balance-sheet/$id': typeof BalanceSheetIdRouteWithChildren
  '/balance-sheet/$id/account-types': typeof BalanceSheetIdAccountTypesRoute
  '/balance-sheet/$id/accounts': typeof BalanceSheetIdAccountsRoute
  '/balance-sheet/$id/dashboard': typeof BalanceSheetIdDashboardRoute
  '/balance-sheet/$id/settings': typeof BalanceSheetIdSettingsRoute
  '/balance-sheet/$id/table': typeof BalanceSheetIdTableRoute
  '/balance-sheet/$id/': typeof BalanceSheetIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/balance-sheet': typeof BalanceSheetRouteWithChildren
  '/balance-sheets': typeof BalanceSheetsRoute
  '/balance-sheet/$id/account-types': typeof BalanceSheetIdAccountTypesRoute
  '/balance-sheet/$id/accounts': typeof BalanceSheetIdAccountsRoute
  '/balance-sheet/$id/dashboard': typeof BalanceSheetIdDashboardRoute
  '/balance-sheet/$id/settings': typeof BalanceSheetIdSettingsRoute
  '/balance-sheet/$id/table': typeof BalanceSheetIdTableRoute
  '/balance-sheet/$id': typeof BalanceSheetIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/balance-sheet': typeof BalanceSheetRouteWithChildren
  '/balance-sheets': typeof BalanceSheetsRoute
  '/balance-sheet/$id': typeof BalanceSheetIdRouteWithChildren
  '/balance-sheet/$id/account-types': typeof BalanceSheetIdAccountTypesRoute
  '/balance-sheet/$id/accounts': typeof BalanceSheetIdAccountsRoute
  '/balance-sheet/$id/dashboard': typeof BalanceSheetIdDashboardRoute
  '/balance-sheet/$id/settings': typeof BalanceSheetIdSettingsRoute
  '/balance-sheet/$id/table': typeof BalanceSheetIdTableRoute
  '/balance-sheet/$id/': typeof BalanceSheetIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/balance-sheet'
    | '/balance-sheets'
    | '/balance-sheet/$id'
    | '/balance-sheet/$id/account-types'
    | '/balance-sheet/$id/accounts'
    | '/balance-sheet/$id/dashboard'
    | '/balance-sheet/$id/settings'
    | '/balance-sheet/$id/table'
    | '/balance-sheet/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/balance-sheet'
    | '/balance-sheets'
    | '/balance-sheet/$id/account-types'
    | '/balance-sheet/$id/accounts'
    | '/balance-sheet/$id/dashboard'
    | '/balance-sheet/$id/settings'
    | '/balance-sheet/$id/table'
    | '/balance-sheet/$id'
  id:
    | '__root__'
    | '/'
    | '/balance-sheet'
    | '/balance-sheets'
    | '/balance-sheet/$id'
    | '/balance-sheet/$id/account-types'
    | '/balance-sheet/$id/accounts'
    | '/balance-sheet/$id/dashboard'
    | '/balance-sheet/$id/settings'
    | '/balance-sheet/$id/table'
    | '/balance-sheet/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BalanceSheetRoute: typeof BalanceSheetRouteWithChildren
  BalanceSheetsRoute: typeof BalanceSheetsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/balance-sheets': {
      id: '/balance-sheets'
      path: '/balance-sheets'
      fullPath: '/balance-sheets'
      preLoaderRoute: typeof BalanceSheetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/balance-sheet': {
      id: '/balance-sheet'
      path: '/balance-sheet'
      fullPath: '/balance-sheet'
      preLoaderRoute: typeof BalanceSheetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/balance-sheet/$id': {
      id: '/balance-sheet/$id'
      path: '/$id'
      fullPath: '/balance-sheet/$id'
      preLoaderRoute: typeof BalanceSheetIdRouteImport
      parentRoute: typeof BalanceSheetRoute
    }
    '/balance-sheet/$id/': {
      id: '/balance-sheet/$id/'
      path: '/'
      fullPath: '/balance-sheet/$id/'
      preLoaderRoute: typeof BalanceSheetIdIndexRouteImport
      parentRoute: typeof BalanceSheetIdRoute
    }
    '/balance-sheet/$id/table': {
      id: '/balance-sheet/$id/table'
      path: '/table'
      fullPath: '/balance-sheet/$id/table'
      preLoaderRoute: typeof BalanceSheetIdTableRouteImport
      parentRoute: typeof BalanceSheetIdRoute
    }
    '/balance-sheet/$id/settings': {
      id: '/balance-sheet/$id/settings'
      path: '/settings'
      fullPath: '/balance-sheet/$id/settings'
      preLoaderRoute: typeof BalanceSheetIdSettingsRouteImport
      parentRoute: typeof BalanceSheetIdRoute
    }
    '/balance-sheet/$id/dashboard': {
      id: '/balance-sheet/$id/dashboard'
      path: '/dashboard'
      fullPath: '/balance-sheet/$id/dashboard'
      preLoaderRoute: typeof BalanceSheetIdDashboardRouteImport
      parentRoute: typeof BalanceSheetIdRoute
    }
    '/balance-sheet/$id/accounts': {
      id: '/balance-sheet/$id/accounts'
      path: '/accounts'
      fullPath: '/balance-sheet/$id/accounts'
      preLoaderRoute: typeof BalanceSheetIdAccountsRouteImport
      parentRoute: typeof BalanceSheetIdRoute
    }
    '/balance-sheet/$id/account-types': {
      id: '/balance-sheet/$id/account-types'
      path: '/account-types'
      fullPath: '/balance-sheet/$id/account-types'
      preLoaderRoute: typeof BalanceSheetIdAccountTypesRouteImport
      parentRoute: typeof BalanceSheetIdRoute
    }
  }
}

interface BalanceSheetIdRouteChildren {
  BalanceSheetIdAccountTypesRoute: typeof BalanceSheetIdAccountTypesRoute
  BalanceSheetIdAccountsRoute: typeof BalanceSheetIdAccountsRoute
  BalanceSheetIdDashboardRoute: typeof BalanceSheetIdDashboardRoute
  BalanceSheetIdSettingsRoute: typeof BalanceSheetIdSettingsRoute
  BalanceSheetIdTableRoute: typeof BalanceSheetIdTableRoute
  BalanceSheetIdIndexRoute: typeof BalanceSheetIdIndexRoute
}

const BalanceSheetIdRouteChildren: BalanceSheetIdRouteChildren = {
  BalanceSheetIdAccountTypesRoute: BalanceSheetIdAccountTypesRoute,
  BalanceSheetIdAccountsRoute: BalanceSheetIdAccountsRoute,
  BalanceSheetIdDashboardRoute: BalanceSheetIdDashboardRoute,
  BalanceSheetIdSettingsRoute: BalanceSheetIdSettingsRoute,
  BalanceSheetIdTableRoute: BalanceSheetIdTableRoute,
  BalanceSheetIdIndexRoute: BalanceSheetIdIndexRoute,
}

const BalanceSheetIdRouteWithChildren = BalanceSheetIdRoute._addFileChildren(
  BalanceSheetIdRouteChildren,
)

interface BalanceSheetRouteChildren {
  BalanceSheetIdRoute: typeof BalanceSheetIdRouteWithChildren
}

const BalanceSheetRouteChildren: BalanceSheetRouteChildren = {
  BalanceSheetIdRoute: BalanceSheetIdRouteWithChildren,
}

const BalanceSheetRouteWithChildren = BalanceSheetRoute._addFileChildren(
  BalanceSheetRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BalanceSheetRoute: BalanceSheetRouteWithChildren,
  BalanceSheetsRoute: BalanceSheetsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
